import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickActions = () => {
  const quickActions = [
    {
      id: 1,
      title: "Create Admin User",
      description: "Add new administrator to the platform",
      icon: "UserPlus",
      color: "bg-primary",
      action: () => console.log('Create admin user')
    },
    {
      id: 2,
      title: "System Backup",
      description: "Initiate full system backup",
      icon: "Database",
      color: "bg-secondary",
      action: () => console.log('System backup')
    },
    {
      id: 3,
      title: "Send Announcement",
      description: "Broadcast message to all users",
      icon: "Megaphone",
      color: "bg-accent",
      action: () => console.log('Send announcement')
    },
    {
      id: 4,
      title: "Generate Report",
      description: "Create comprehensive platform report",
      icon: "FileText",
      color: "bg-success",
      action: () => console.log('Generate report')
    },
    {
      id: 5,
      title: "Maintenance Mode",
      description: "Enable platform maintenance mode",
      icon: "Settings",
      color: "bg-warning",
      action: () => console.log('Maintenance mode')
    },
    {
      id: 6,
      title: "Clear Cache",
      description: "Clear all system caches",
      icon: "RefreshCw",
      color: "bg-error",
      action: () => console.log('Clear cache')
    }
  ];

  return (
    <div className="bg-card rounded-lg border border-border shadow-sm p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-foreground">Quick Actions</h3>
          <p className="text-sm text-muted-foreground">Common administrative tasks</p>
        </div>
        <Button variant="outline" size="sm" iconName="Plus">
          Add Action
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {quickActions?.map((action) => (
          <button
            key={action?.id}
            onClick={action?.action}
            className="p-4 bg-muted rounded-lg hover:bg-muted/80 transition-colors text-left group"
          >
            <div className="flex items-start space-x-3">
              <div className={`w-10 h-10 ${action?.color} rounded-lg flex items-center justify-center group-hover:scale-105 transition-transform`}>
                <Icon name={action?.icon} size={20} color="white" />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="text-sm font-medium text-foreground group-hover:text-primary transition-colors">
                  {action?.title}
                </h4>
                <p className="text-xs text-muted-foreground mt-1">
                  {action?.description}
                </p>
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;